export default __webpack_public_path__ + "static/media/ISCO CLASS-7_SYLLABUS_2025-26.727460ac.pdf";